/**
 * Move payment method to the first place in the array (Make it default)
 * @param {Array} paymentMethods
 * @param {string} movingPaymentMethodId
 * @returns {Array}
 */
export default (paymentMethods, movingPaymentMethodId) => {
	const movingPaymentMethod = paymentMethods.find((paymentMethod) => paymentMethod.id === movingPaymentMethodId);
	const modifiedPaymentMethods = paymentMethods.filter((paymentMethod) => paymentMethod.id !== movingPaymentMethodId); // Remove "moving" PM so we can later add it back with different position in the array
	if (movingPaymentMethod) {
		// Add previously removed PM to modified array in first position
		modifiedPaymentMethods.unshift(movingPaymentMethod);
	}
	return modifiedPaymentMethods;
};
